<script lang="ts">
    import {
        isLocalTorchAvailable,
        localMediaState,
        localVideoStore,
        muteLocalAudio,
        pauseLocalVideoStream,
        resumeLocalVideoStream,
        unmuteLocalAudio,
    } from "../../../../stores/localVideoStore";
    import { roomStore } from "../../../../stores/roomStore";
    import { closeCall } from "../../../../utils/closeCall";
    import CameraControls from "./CameraControls.svelte";
    import { pointerStore } from "../../../../stores/pointerStore";
    import { videoDevicesStore } from "../../../../utils/mediaDevices";
    import { switchLocalVideo } from "../../../../stores/peerConnectionStore";
    import {
        localTorchState,
        turnOffLocalTorchFromSelf,
        turnOnLocalTorchFromSelf,
    } from "../../../../stores/torchStore";
    import LocalMediaView from "../LocalMediaView.svelte";
    import ErrorScreen from "../../../ErrorScreen/ErrorScreen.svelte";
    import { translation } from "../../../../stores";

    let torchOn = false;
    let torchAvailable = false;

    $: room = $roomStore;
    $: pointerPosition = $pointerStore;
    $: showSwitchCamera = $videoDevicesStore.length > 1;
    $: mediaState = $localMediaState;

    $: torchOn = $localTorchState.torchOn;

    $: if ($localVideoStore) {
        torchAvailable = isLocalTorchAvailable();
    }

    function hangup() {
        console.log("[CameraCall] hangup");
        closeCall(room.id);
    }

    async function toggleTorch() {
        if (torchOn) {
            await turnOffLocalTorchFromSelf();
        } else {
            await turnOnLocalTorchFromSelf();
        }
    }
</script>

{#if room}
    <div class="grid grid-cols-6 gap-2 p-4 bg-gray-100 rounded-lg shadow-lg">
        <div class="col-span-6">
            <LocalMediaView
                stream={$localVideoStore}
                {mediaState}
                {pointerPosition}
            />
        </div>

        <div class="col-span-6 flex justify-center space-x-2 py-1">
            <CameraControls
                paused={mediaState.videoPaused}
                muted={mediaState.audioMuted}
                audioEnabled={room.audioEnabled}
                {showSwitchCamera}
                {torchOn}
                {torchAvailable}
                videoPauseOrigin={mediaState.videoPauseOrigin}
                audioMuteOrigin={mediaState.audioMuteOrigin}
                onPause={pauseLocalVideoStream}
                onResume={resumeLocalVideoStream}
                onMute={() => muteLocalAudio("self")}
                onUnmute={() => unmuteLocalAudio("self")}
                onTorch={toggleTorch}
                onHangup={hangup}
                onSwitchCamera={switchLocalVideo}
            />
        </div>
    </div>
{:else}
    <ErrorScreen title={translation.alert.sessionFullError}/>
{/if}
